var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEmptyStateTrackersFound = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 260,
    viewBox: "0 0 400 260",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5478_126527)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M225.56 73.5838C225.56 73.5838 240.801 66.8953 243.881 70.5965C246.962 74.2977 234.836 77.1253 234.836 77.1253C234.836 77.1253 256.078 79.4879 257.485 83.6353C258.892 87.7827 249.856 86.2233 249.856 86.2233C249.856 86.2233 259.689 88.0363 258.92 91.9113C258.156 95.791 249.148 92.6018 249.148 92.6018C249.148 92.6018 255.928 94.908 254.761 98.1348C253.588 101.362 245.781 97.2471 245.781 97.2471C245.781 97.2471 250.081 99.6237 247.914 102.118C245.743 104.621 220.913 92.8648 220.913 92.8648L225.565 73.5791L225.56 73.5838Z",
    fill: "#071A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.023 34.9604C116.023 41.2121 121.073 46.2707 127.305 46.2707C133.537 46.2707 138.597 41.2121 138.597 34.9604C138.597 33.1427 138.17 31.4189 137.401 29.9018C135.549 26.1959 131.722 23.6501 127.305 23.6501C121.927 23.6501 117.42 27.4312 116.295 32.4804C116.112 33.2789 116.023 34.1056 116.023 34.9604Z",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.586 31.4378C116.224 31.3298 115.84 31.2734 115.441 31.2734C113.228 31.2734 111.441 33.0724 111.441 35.2893C111.441 37.5063 113.228 39.2959 115.441 39.2959C115.915 39.2959 116.365 39.216 116.782 39.061",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.405 37.0601C138.879 37.2526 139.385 37.3607 139.92 37.3607C142.133 37.3607 143.929 35.5617 143.929 33.3448C143.929 31.1278 142.133 29.3289 139.92 29.3289C139.015 29.3289 138.18 29.6295 137.51 30.1367",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.706 36.0454C133.706 36.0454 133.083 41.2027 127.259 41.198C122.668 41.198 120.862 36.8674 120.862 36.8674",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.984 118.355C192.984 118.355 207.281 112.169 210.775 115.636C214.268 119.102 202.69 123.508 202.69 123.508C202.69 123.508 223.895 123.381 225.799 127.519C227.708 131.652 218.615 131.126 218.615 131.126C218.615 131.126 228.519 131.817 228.252 135.931C227.984 140.046 218.718 137.833 218.718 137.833C218.718 137.833 225.682 139.402 224.936 142.897C224.191 146.391 215.985 143.066 215.985 143.066C215.985 143.066 220.514 145.01 218.695 147.861C216.871 150.722 190.958 141.535 190.958 141.535L192.974 118.355H192.984Z",
    fill: "#071A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.0458 96.6425C82.4817 119.872 93.0067 136.713 103.118 148.308C109.585 142.901 117.922 139.285 128.661 139.139C138.921 139.003 147.047 142.075 153.476 146.908C179.464 117.59 181.776 89.9103 181.776 89.9103C170.02 86.0917 160.487 81.0143 152.914 75.7819C145.983 71.0003 140.689 66.0967 136.825 61.9258C130.944 55.5755 128.37 50.9067 128.37 50.9067C125.613 55.8432 122.564 60.1551 119.343 63.9173C113.303 71.0191 106.71 76.1811 100.506 79.9058V79.9105C98.8974 80.8775 97.3159 81.7486 95.7779 82.533",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.118 148.303C116.079 163.174 128.37 169.406 128.37 169.406C138.545 162.093 146.789 154.442 153.476 146.903C147.047 142.07 138.921 138.998 128.66 139.134C117.922 139.28 109.584 142.897 103.118 148.303Z",
    fill: "#071A24",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.949 246C130.949 246 103.531 180.928 128.661 176.213C151.127 171.999 173.861 211.167 173.861 211.167L226.32 182.915L191.727 181.736C191.727 181.736 178.841 159.444 153.472 146.904C146.789 154.442 138.541 162.094 128.365 169.407C128.365 169.407 116.075 163.174 103.113 148.303C70.7058 167.984 95.6622 233.408 95.6622 233.408L67.2639 246H130.944H130.949Z",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.727 181.736L164.529 197.79L173.589 210.867L226.32 182.915L191.727 181.736Z",
    fill: "#071A24",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.6668 233.407L126.053 233.135L130.949 246H67.2685L95.6668 233.407Z",
    fill: "#071A24",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.137 31.5036C115.019 32.1847 115.769 32.5369 115.769 32.5369L116.294 32.4806C117.42 27.4313 121.926 23.6503 127.305 23.6503C131.722 23.6503 135.549 26.196 137.401 29.9019C139.159 28.9673 142.479 26.5201 140.468 22.0815C137.926 16.4921 131.844 20.3014 131.844 20.3014C131.844 20.3014 130.573 13.0445 123.891 14.1061C116.534 15.2803 118.667 21.8748 118.667 21.8748C118.667 21.8748 113.88 20.151 111.901 24.9748C110.63 28.0654 112.581 30.2965 114.142 31.5083L114.137 31.5036Z",
    fill: "#071A24",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.844 141.042L193.227 119.172C192.557 118.942 131.685 96.9887 96.9657 83.2078C92.1217 81.2867 90.4007 78.8819 90.246 78.0928C90.0656 77.173 91.6809 76.7354 94.5742 76.2704C145.528 68.0554 219.033 93.0855 219.952 93.372L225.105 71.6721C221.147 70.418 147.193 45.4254 91.0713 54.4765C78.4337 56.515 69.5053 64.8239 68.3236 75.6504C67.6812 81.5169 69.4725 87.5431 73.3646 92.6205C76.9472 97.294 82.3024 101.136 88.8392 103.734C124.037 117.707 191.164 140.816 191.839 141.046L191.844 141.042Z",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.47 74.6501C122.513 73.9502 139.666 75.472 156.473 77.999C155.136 77.1676 153.852 76.3175 152.623 75.4673C145.692 70.6905 140.393 65.7869 136.529 61.616C133.153 57.9664 130.865 54.8711 129.528 52.8984C128.633 52.842 127.732 52.7904 126.837 52.7434C124.417 56.7922 121.796 60.3995 119.052 63.6028C115.329 67.9851 111.395 71.6299 107.47 74.6501Z",
    fill: "#071A24",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.0265 96.4673C80.2433 99.3747 84.2527 101.812 88.8435 103.635C97.6265 107.12 108.398 111.173 119.624 115.302L131.638 119.68C143.46 123.959 155.188 128.125 165.115 131.619C169.785 124.499 173.157 117.787 175.586 111.906C152.843 103.917 118.667 91.728 96.9653 83.1091C96.4823 82.9165 96.0369 82.7239 95.6148 82.522",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.077 89.6841L292.564 125.55L271.567 141.721L270.431 142.592L246.885 160.727L216.243 128.249L194.317 105.705L239.077 89.6841Z",
    fill: "white",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.339 139.415L219.892 102.068L237.911 94.6428L284.004 125.509L265.339 139.415Z",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.859 120.177L228.482 114.291L241.404 125.84L228.826 133.047L215.859 120.177Z",
    fill: "#071A24",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.337 99.4097L271.082 135.141",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.965 96.679L238.209 100.591L244.18 105.047L250.267 109.586L257.137 114.7L263.658 119.565L270.3 124.519L277.816 130.125",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.337 106.384L242.554 98.4768",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.707 102.43L244.18 105.047L237.921 108.663L232.051 112.057",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.26 120.322L270.299 124.518L263.647 129.202L258.529 132.804",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.422 115.741L263.658 119.565L257.061 123.949L251.373 127.721",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.846 122.576L250.671 118.845L257.137 114.7L262.623 111.187",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.335 117.223L244.053 113.56L250.267 109.586L255.359 106.322",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.938 68.7564L248.934 47.1292L239.072 89.6841L292.558 125.508L314.938 68.7564Z",
    fill: "white",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.419 72.2644L252.13 51.8496L243.439 88.6221L290.192 117.519L307.419 72.2644Z",
    fill: "white",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.972 60.3921L281.675 80.6824C282.927 82.2041 285.176 82.3013 286.552 80.8929L322.485 44.2641C323.698 43.0309 325.616 42.9303 326.932 44.0357L335.17 50.953C336.77 52.2951 336.798 54.806 335.231 56.2015L285.884 100.098C284.528 101.303 282.489 101.193 281.272 99.8486L254.225 69.9091C252.926 68.4745 253.072 66.2052 254.537 64.9466L260.301 59.99C261.706 58.7797 263.792 58.9616 264.97 60.3963L264.972 60.3921Z",
    fill: "#4767FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.506 23.8314C315.195 22.5138 316.012 21.1934 317.329 20.8824C318.647 20.5714 319.967 21.3875 320.278 22.7052C320.589 24.0229 319.773 25.3432 318.455 25.6542C317.138 25.9652 315.817 25.1491 315.506 23.8314Z",
    fill: "#071A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.928 124.912C292.928 124.912 317.123 61.8754 358.898 80.482C394.982 96.5556 371.535 120.366 360.351 108.197C351.892 98.9954 353.413 75.303 365.803 67.1614C380.314 57.6249 390.965 68.5039 385.755 74.6711C379.413 82.1854 368.787 69.4949 362.309 53.5683",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2477 32.8963C31.4782 34.2005 32.7298 35.8153 33.6169 43.2137C33.6696 43.6446 34.2757 43.6446 34.3284 43.2137C35.2133 35.8131 36.4671 34.2005 41.6976 32.8963C42.0643 32.8056 42.0643 32.2681 41.6976 32.1774C36.4671 30.8733 35.2155 29.2584 34.3284 21.8601C34.2757 21.4291 33.6696 21.4291 33.6169 21.8601C32.732 29.2607 31.4782 30.8733 26.2477 32.1774C25.881 32.2681 25.881 32.8056 26.2477 32.8963Z",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.009 220.9C329.173 220.9 324.976 225.1 324.976 230.932C324.976 225.096 320.776 220.9 314.943 220.9C320.78 220.9 324.976 216.699 324.976 210.867C324.976 216.703 329.177 220.9 335.009 220.9Z",
    fill: "#071A24",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.112 32.5497C348.478 29.8632 350.142 27.1708 352.829 26.5363C355.517 25.9018 358.209 27.5658 358.843 30.2535C359.477 32.94 357.813 35.6323 355.126 36.2669C352.438 36.9002 349.746 35.2362 349.112 32.5497Z",
    fill: "#071A24"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5478_126527"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 260,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEmptyStateTrackersFound);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/EmptyStateTrackersFound.9eff6aa5002652e5c3e7b76eb0d9d3e5.svg";